import { Spacer } from "../atoms/Atoms"
import React from "react"
import { useSelector } from "react-redux"
import { HomeCard } from "./Home"
import { getInterest, getJourney } from "../../../reducers/userInfo"
import { getInterestIsFertility } from "derivedSelectors"
import Journeys from "utils/Journeys"
import Interests from "utils/Interests"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { H2 } from "@carrotfertility/carotene"

const EligibilityModuleTemplate = ({ title, bodyCopy, ctas }) => (
  <HomeCard halfWidth>
    <H2>{title}</H2>
    <Spacer height={0.25} />
    <span className="publico-text fw4 lh-copy black-80">{bodyCopy}</span>
    <Spacer height={1} />
    {ctas.map((cta) => (
      <ArrowLink to={cta.uri} key={cta.uri}>
        {cta.name}
      </ArrowLink>
    ))}
  </HomeCard>
)

const EligibilityModule = () => {
  const { interest, journey, interestIsFertility } = useSelector((state) => ({
    interest: getInterest(state),
    journey: getJourney(state),
    interestIsFertility: getInterestIsFertility(state)
  }))

  if ([Journeys.READY_FOR_NEXT_STEP, Journeys.TAKING_ACTION].includes(journey) && interestIsFertility) {
    return (
      <EligibilityModuleTemplate
        title="Will Carrot cover my fertility care?"
        bodyCopy="To make the most of your benefit dollars, see if your provider and
    services are eligible."
        ctas={[
          { uri: "/your-benefit-guide/coverage", name: "Browse eligible care" },
          { uri: "/providerfinder", name: "Browse eligible providers" }
        ]}
      />
    )
  }

  if ([Journeys.READY_FOR_NEXT_STEP, Journeys.TAKING_ACTION].includes(journey) && interest === Interests.ADOPTING) {
    return (
      <EligibilityModuleTemplate
        title="Will Carrot cover my adoption expenses?"
        bodyCopy="To make the most of your benefit dollars, see if your provider and
    services are eligible."
        ctas={[
          { uri: "/eligible-expenses", name: "Browse eligible care" },
          {
            uri: "/talk-to-carrot",
            name: "Contact us to see if your provider is eligible"
          }
        ]}
      />
    )
  }

  if (
    [Journeys.READY_FOR_NEXT_STEP, Journeys.TAKING_ACTION].includes(journey) &&
    interest === Interests.GESTATIONAL_CARRIER
  ) {
    return (
      <EligibilityModuleTemplate
        title="Will Carrot cover my gestational carrier expenses?"
        bodyCopy="To make the most of your benefit dollars, see if your provider and
        services are eligible."
        ctas={[
          { uri: "/eligible-expenses", name: "Browse eligible care" },
          {
            uri: "/talk-to-carrot",
            name: "Contact us to see if your provider is eligible"
          }
        ]}
      />
    )
  }
  console.error("Eligibility module reached impossible state")
  return null
}

export default EligibilityModule
